import { ReactNode, SVGProps } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "./index.module.scss";

type PropsType = {
  children: ReactNode;
  loading?: boolean;
  underline?: boolean;
  disabled?: boolean;
  className?: string;
  icon?: SVGProps<SVGSVGElement>;
  onClick?: () => void;
  to?: string;
  externalURL?: boolean;
  edit?: boolean;
};

/**
 * If to is not passed, TextLink behaves as button (pass onClick)
 *
 * If to is passed, TextLink behaves as Link; onClick can be used for secondary behavior
 */
const TextLink = ({
  children,
  loading,
  underline,
  disabled,
  className,
  icon,
  onClick,
  to,
  externalURL,
  edit,
}: PropsType) => {
  const content = (
    <span
      className={classNames({
        [styles.underline]: underline,
        [styles.editIcon]: edit,
      })}
    >
      {loading ? "...Loading" : children}
      {icon}
    </span>
  );
  if (!to) {
    return (
      <button
        className={classNames(className, styles.textLink, {
          [styles.disabled]: disabled,
        })}
        onClick={onClick}
        type="button"
        aria-label={`Link: ${children}`}
        disabled={loading || disabled}
        aria-live="polite"
      >
        {content}
      </button>
    );
  }
  if (externalURL && to) {
    return (
      <a
        href={to}
        className={classNames(className, styles.textLink, {
          [styles.disabled]: disabled,
        })}
        onClick={onClick} // Side-effect
        aria-label={`Link: ${children}`}
        aria-live="polite"
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  }
  return (
    <Link
      to={to || "/"}
      className={classNames(className, styles.textLink, {
        [styles.disabled]: disabled,
      })}
      onClick={onClick} // Side-effect
      aria-label={`Link: ${children}`}
      aria-live="polite"
    >
      {content}
    </Link>
  );
};

export default TextLink;
